import FormGroup from './Components/FormGroup';
import {FormField, FormFieldProps} from './Components/FormField';
import {FormQuery} from './Components/FormQuery';
import FormFilter from './Components/FormFilter';
import FormSearch from './Components/FormSearch';
import {FormInner, FormInnerProps} from './Components/FormInner';
import TextField from './Components/TextField';

const ProForm = Object.assign(FormInner, {
    Group: FormGroup,
    Field: FormField,
    Filter: FormFilter,
    Query: FormQuery,
    Search: FormSearch,
    TextField: TextField,
});

export type {FormInnerProps as ProFormProps, FormFieldProps};

export default ProForm;
